import { createSlice } from "@reduxjs/toolkit";

const irregularitiesSlice = createSlice({
    name: "irregularities",
    initialState: {
        irregularitiesDetails: null,
        irregularitiesError: null,
        irregularitiesLoading: false,
    },
    reducers: {
        setIrregularitiesDetails: (state, { payload }) => {
            state.irregularitiesDetails = payload;
        },
        setIrregularitiesError: (state, { payload }) => {
            state.irregularitiesError = payload;
        },
        setIrregularitiesLoading: (state, { payload }) => {
            state.irregularitiesLoading = payload;
        },
    }
});

export const { setIrregularitiesDetails, setIrregularitiesError, setIrregularitiesLoading } = irregularitiesSlice.actions;

export default irregularitiesSlice.reducer;